import React from 'react';
import moment from 'moment';
import Field, { fieldTypes } from '../../../../../../shared/ui/Field';
import { selectDateRules } from '../../../../../../shared/constants/fieldsData';
import { fieldNames } from '../../../config';
import { validateToEndAndPlanEndDate } from '../../../lib/fieldValidators';

const StartDateField = ({ initialValue, form, fieldProps }) => {
  return (
    <Field
      fieldType={fieldTypes.rangePicker}
      form={form}
      name={fieldNames.startDate}
      label="Дата начала"
      decoratorOptions={{
        rules: [
          ...selectDateRules,
          {
            validator: validateToEndAndPlanEndDate(form),
          },
        ],
        initialValue: initialValue ? moment(initialValue) : null,
      }}
      fieldProps={fieldProps}
    />
  );
};

export default StartDateField;
